// どの種別の電車が、どのレーンを走るのかを返す
class TrainLaneData {
  // 駅に停車中はその駅IDを与えればよい
  // 駅間はnextStationIdを与えればよい
  static getByStationIdAndTrainNumber = (stationId, trainNumber) => {
    const stationIdInt = parseInt(stationId, 10)
    if (parseInt(trainNumber, 10) >= 50) {
      return 'inner'
    } else {
      return 'outer'
    } 
  }
}

export default TrainLaneData